import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-progressbar-stepper',
  templateUrl: './progressbar-stepper.component.html',
  styleUrls: ['./progressbar-stepper.component.css'],
  standalone: false,
})
export class ProgressbarStepperComponent {
  @Input() currentStep = 1;
  @Input() steps = 4;
}
